// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__uU6u5","title":"Header_title__38qWd","side":"Header_side__bVNtZ"};